/**
 * Valores monetários trafegam como string decimal (nunca float — RNF-06,
 * `MoneyStringSchema` em `@serviquim/contracts`). Este módulo só formata pra
 * exibição e normaliza a entrada do usuário; a fonte da verdade é sempre a string.
 */

import type { CurrencyDTO } from '@serviquim/contracts';

const MONEY_INPUT_RE = /^-?\d+([.,]\d{0,4})?$/;

/**
 * Formata "1150.5" → "1.150,50" (pt-BR/es-PY, 2 casas fixas na tela). Passando o
 * código da moeda (`trip.moeda`), exibe também o símbolo/código: "US$ 1.150,50".
 */
export function formatMoney(value: string, currency?: CurrencyDTO): string {
  const n = Number(value);
  if (Number.isNaN(n)) return value;
  return new Intl.NumberFormat('pt-BR', {
    ...(currency ? { style: 'currency' as const, currency } : {}),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

/** Aceita "," ou "." como separador decimal enquanto o usuário digita. */
export function isValidMoneyInput(raw: string): boolean {
  return raw.length > 0 && MONEY_INPUT_RE.test(raw);
}

/** Normaliza a entrada do usuário (vírgula → ponto) pro formato do contrato. */
export function normalizeMoneyInput(raw: string): string {
  return raw.trim().replace(',', '.');
}

export function sumMoney(values: readonly string[]): string {
  const total = values.reduce((acc, v) => acc + (Number(v) || 0), 0);
  return total.toFixed(4);
}
